import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import UserContextProvider from './context/UserContext';
import LicenceContextProvider from './context/LicenceContext';

/**
 * @file Main file 
 */

ReactDOM.render(
  <UserContextProvider>
    <LicenceContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LicenceContextProvider>
  </UserContextProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
